import DatePickerReducer from "./date-picker-reducer";

export const setGetDate = (payload) => (dispatch) => {
  dispatch(DatePickerReducer.actions.setDate(payload));
};
export const clearDate = () => (dispatch) => {
  dispatch(DatePickerReducer.actions.clearDate());
};
